import Favicon from '@coconut/static/favicon.ico';
import FaviconHasUnread from '@coconut/static/favicon_notification.ico';

const UNREAD_COUNT_REGEX = /\([0-9]{0,6}\) /i;

export default function (unreadCount = 0) {
  const originalTitle = document.title.replace(UNREAD_COUNT_REGEX, '');
  const faviconElement = document.querySelector("link[rel*='icon']");

  if (!unreadCount) {
    document.title = originalTitle;
    faviconElement.href = Favicon;
    return;
  }

  const unreadTitle = `(${unreadCount}) ${originalTitle}`;
  document.title = unreadTitle;
  faviconElement.href = FaviconHasUnread;
}



// WEBPACK FOOTER //
// ./src/utils/setPageTitleIcon.js